import {ErrorMessage, Form, Formik} from 'formik'
import {isEmpty} from 'lodash'
import {useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {toast} from 'react-toastify'
import * as Yup from 'yup'

import * as place from 'src/app/modules/common'
import {StateParamsModel} from 'src/app/modules/common/Model'
import * as setting from 'src/app/modules/siteSettings/components/settings'
import * as branch from '../index'

import Modal from 'rsuite/Modal'
import {OptionModel, PlaceModel} from '../Model'

import FormCheckbox from 'src/cms/helpers/components/forms/FormCheckbox'
import FormRadio from 'src/cms/helpers/components/forms/FormRadio'
import FormSelect from 'src/cms/helpers/components/forms/FormSelect'
import FormTextBox from 'src/cms/helpers/components/forms/FormTextBox'

import moment from 'moment'
import checkBackendSetting from 'src/app/modules/common/checkBackendSetting'
import checkMultiLanguage from 'src/app/modules/common/checkMultiLanguage'
import {ISettingTypeState} from 'src/app/modules/siteSettings/components/settings'
import FormDatepicker from 'src/cms/helpers/components/forms/FormDatepicker'
import FormTinyMce from 'src/cms/helpers/components/forms/FormTinyMce'
import MapView from '../../../../common/components/Map/MapView'
import getBackendSettingValue from 'src/app/modules/common/getBackendSetting'

type Props = {
  open: boolean
  params?: StateParamsModel
  handleClose: () => void
  actionType: string
  editSelectedData?: any
}
const AddBranch = ({open, params, handleClose, actionType, editSelectedData}: Props) => {
  const dispatch = useDispatch()
  const [provinceValue, setProvinceValue] = useState('')
  const [branchCategoryValue, setBranchCategoryValue] = useState('')
  const [valleyProvinceOptions, setValleyProvinceOptions] = useState([])
  const [valleyDistrictOptions, setValleyDistrictOptions] = useState([])
  const [location, setLocation] = useState({lat: '', lng: ''})
  const {category, branchExtendedHourStatus, loading, success} = useSelector(
    (state: any) => state.branch
  )
  const {district, province} = useSelector((state: any) => state.place)

  const settings: ISettingTypeState = useSelector((state: any) => state.settingType)
  // Check backend Setting
  const branchVisibility = checkBackendSetting('showBranchInWebsite')
  const showIframe = checkBackendSetting('showAtmBranchLocationInIframe')
  const branchExtendedHourRequired = checkBackendSetting('branchExtendedHourRequired')
  const branchStatusRequired = checkBackendSetting('branchStatusRequired')
  const showQOS = checkBackendSetting('showQos')
  const showCashCounterStatus = checkBackendSetting('showCounterStatus')
  const branchExtendFromDes = checkBackendSetting('branchExtendFrom')

  const defaultLongitude = getBackendSettingValue('defaultLongitude')
  const defaultLatitude = getBackendSettingValue('defaultLatitude')
  const showCounterHolidayBasedBranch = getBackendSettingValue('counterHolidayBasedBranch')
  const phoneNumberValidation = checkBackendSetting('phoneNumberValidation')
  const showCrm = checkBackendSetting('enableCrmProduct')

  let FORM_VALIDATION = Yup.object().shape({
    branchExtendedId: Yup.string().when('branchExtendedHourRequired', {
      is: (value: any) => !value && branchExtendedHourRequired,
      then: Yup.string().required('Branch extended hour is required'),
      otherwise: Yup.string(),
    }),
    title: Yup.string().required('Branch title is required'),
    code: Yup.string()
      .required('Branch Code is required')
      .matches(/^[A-Za-z0-9\s]*$/, 'Must not contain symbol'),
    email: Yup.string()
      .email('Invalid Email. Eg: example@xyz.com')
      .matches(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i, 'Please provide valid email')
      .nullable(),
    fax: Yup.string()
      .matches(/^[0-9#$%^&*()@!-/., ]*$/, 'Must contain only numbers')
      .nullable(),
    status: Yup.string().when('branchStatusRequired', {
      is: (value: any) => !value && branchStatusRequired,
      then: Yup.string().required('Brach Status is required'),
      otherwise: Yup.string(),
    }),
  })
  if (phoneNumberValidation) {
    FORM_VALIDATION = FORM_VALIDATION.shape({
      telephone: Yup.string()
        .matches(
          /^[a-zA-Z0-9.:+\-\/\\, ]+$/,
          'Must contain only alphanumerical characters and the symbols (- + : , /.)'
        )
        .nullable(),
    })
  } else {
    FORM_VALIDATION = FORM_VALIDATION.shape({
      telephone: Yup.string()
        .matches(/^[0-9#$%^&*()@!-/., ]*$/, 'Must contain only numbers')
        .nullable(),
    })
  }

  const persistSettings = JSON.parse(localStorage.getItem('persist:settings') as string)
  const backendData = JSON.parse(persistSettings.backendData)
  const branchData = backendData['Branch Settings'].find(
    (item: {[key: string]: string | []}) => item.name === 'branchExtendFrom'
  )

  useEffect(() => {
    if (!isEmpty(editSelectedData)) {
      setLocation({lat: editSelectedData?.latitude, lng: editSelectedData?.longitude})
    }
  }, [editSelectedData])

  useEffect(() => {
    dispatch(setting.actions.getSettingType())
    dispatch(branch.actions.getBranchCategory())
    dispatch(branch.actions.getExtendedHour())
    dispatch(place.action.getProvince())
  }, [])

  useEffect(() => {
    if (provinceValue) {
      dispatch(place.action.getDistrict(provinceValue))
    }
  }, [provinceValue])

  const statusOptions = [
    {label: 'Active', value: 'Active'},
    {label: 'Inactive', value: 'Inactive'},
  ]

  const counterHolidayOptions = [
    {label: 'True', value: 'true'},
    {label: 'False', value: 'false'},
  ]

  const categoryOptions = category?.map((items: OptionModel) => ({
    label: items.displayName,
    value: items.id,
    systemName: items.systemName,
  }))

  const extendedHours = branchExtendedHourStatus?.map((items: OptionModel) => ({
    label: items.display_name,
    value: items.id,
    systemName: items.system_name,
  }))

  const districtOptions = district?.map((items: PlaceModel) => ({
    label: items.title,
    value: items.id,
  }))

  const provinceOptions = province?.map((items: PlaceModel) => ({
    label: items.title,
    value: items.id,
  }))

  useEffect(() => {
    if (!province) return
    if (branchCategoryValue === 'e142aa7f-d275-43cf-87a7-503872a9274a') {
      const provinceOptions = province
        ?.filter((d: any) => d.title === 'Bagmati Pradesh')
        .map((items: PlaceModel) => ({
          label: items.title,
          value: items.id,
        }))
      setValleyProvinceOptions(provinceOptions)
    } else {
      const provinceOptions = province?.map((items: PlaceModel) => ({
        label: items.title,
        value: items.id,
      }))
      setValleyProvinceOptions(provinceOptions)
    }
  }, [branchCategoryValue, province])

  useEffect(() => {
    if (!isEmpty(branchCategoryValue) && !isEmpty(provinceValue)) {
      if (branchCategoryValue === 'e142aa7f-d275-43cf-87a7-503872a9274a') {
        const districtOptions = district
          ?.filter((d: any) => d.categoryId === 'e142aa7f-d275-43cf-87a7-503872a9274a')
          .map((items: PlaceModel) => ({
            label: items.title,
            value: items.id,
          }))
        setValleyDistrictOptions(districtOptions)
      } else {
        const districtOptions = district
          ?.filter((d: any) => d.categoryId !== 'e142aa7f-d275-43cf-87a7-503872a9274a')
          .map((items: PlaceModel) => ({
            label: items.title,
            value: items.id,
          }))
        setValleyDistrictOptions(districtOptions)
      }
    }
  }, [branchCategoryValue, provinceValue, district])

  useEffect(() => {
    if (success) {
      dispatch(branch?.actions.getBranchData(params))
      isEmpty(editSelectedData)
        ? toast.success('Branch added successfully')
        : toast.success('Branch edited successfully')
      dispatch(branch?.actions?.resetBranch())
      handleClose()
    }
  }, [success])
  useEffect(() => {
    if (!isEmpty(editSelectedData)) {
      setProvinceValue(editSelectedData?.province?.id)
      setBranchCategoryValue(editSelectedData?.branch_category?.id)
    }
  }, [])

  const hideMultiLanguage = checkMultiLanguage() // check multi language and hide np filed

  return (
    <div className='modal-container'>
      <Modal
        open={open}
        onClose={handleClose}
        className='w-75'
        backdrop='static'
        keyboard={false}
        enforceFocus={false}
        data-cy='modal'
      >
        <Modal.Header>
          <Modal.Title data-cy='modal-title'>{actionType} Branch</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <Formik
              initialValues={{
                branchCategoryId: '',
                code: '',
                title: '',
                provinceId: '',
                status: '',
                branchExtendedId: '',
                latitude: '',
                longitude: '',
                upcomingBranchStatus: false,
                cashCounterStatus: false,
                hide_in_website: false,
                openingTime: null,
                closingTime: null,
                qos: false,
                plus_code: '',
                has_evening_counter: 'false',
                has_public_holiday: 'false',
                opens_saturday: 'false',
                opens_sunday: 'false',
                sudden_holiday: 'false',
                crm_code: '',
              }}
              validationSchema={FORM_VALIDATION}
              onSubmit={(values, {setSubmitting}) => {
                const formData = {
                  ...values,
                  longitude: values?.longitude ? values?.longitude.toString() : '',
                  latitude: values?.latitude ? values?.latitude.toString() : '',
                  status: values?.status === 'Active' ? true : false,
                  openingTime: values?.openingTime
                    ? moment(values?.openingTime).format('HH:mm')
                    : null,
                  closingTime: values?.closingTime
                    ? moment(values?.closingTime).format('HH:mm')
                    : null,
                  has_evening_counter: values?.has_evening_counter === 'true' ? true : false,
                  has_public_holiday: values?.has_public_holiday === 'true' ? true : false,
                  opens_saturday: values?.opens_saturday === 'true' ? true : false,
                  opens_sunday: values?.opens_sunday === 'true' ? true : false,
                  sudden_holiday: values?.sudden_holiday === 'true' ? true : false,
                }
                if (!isEmpty(editSelectedData)) {
                  dispatch(branch.actions.updateBranch(formData, editSelectedData?.id))
                } else {
                  dispatch(branch.actions.addBranch(formData))
                }
              }}
            >
              {({isSubmitting, touched, handleChange, errors, values, setFieldValue}) => {
                useEffect(() => {
                  if (!isEmpty(editSelectedData)) {
                    const fields = [
                      'address',
                      'address_np',
                      'closingTime',
                      'code',
                      'description',
                      'description_np',
                      'email',
                      'fax',
                      'id',
                      'qos',
                      'openingTime',
                      'telephone',
                      'title',
                      'title_np',
                      'latitude',
                      'longitude',
                      'iframe',
                      'plus_code',
                      'has_evening_counter',
                      'has_public_holiday',
                      'opens_saturday',
                      'opens_sunday',
                      'sudden_holiday',
                    ]

                    fields.forEach((field) => setFieldValue(field, editSelectedData[field], false))

                    setFieldValue('crm_code', editSelectedData?.crm_code, false)
                    setFieldValue('branchCategoryId', editSelectedData?.branch_category?.id, false)
                    setFieldValue('provinceId', editSelectedData?.province?.id, false)
                    setFieldValue('districtId', editSelectedData?.district?.id, false)
                    setFieldValue('branchExtendedId', editSelectedData?.extended_hour?.id, false)
                    setFieldValue('upcomingBranchStatus', editSelectedData?.upcoming_branch, false)
                    setFieldValue('cashCounterStatus', editSelectedData?.cash_counter, false)
                    setFieldValue('qos', editSelectedData?.qos, false)
                    setFieldValue('hide_in_website', editSelectedData?.hide_in_website, false)
                    setFieldValue(
                      'status',
                      editSelectedData?.status === true ? 'Active' : 'Inactive',
                      false
                    )
                    setFieldValue(
                      'has_evening_counter',
                      editSelectedData?.has_evening_counter === true ? 'true' : 'false',
                      false
                    )
                    setFieldValue(
                      'has_public_holiday',
                      editSelectedData?.has_public_holiday === true ? 'true' : 'false',
                      false
                    )
                    setFieldValue(
                      'opens_saturday',
                      editSelectedData?.opens_saturday === true ? 'true' : 'false',
                      false
                    )
                    setFieldValue(
                      'opens_sunday',
                      editSelectedData?.opens_sunday === true ? 'true' : 'false',
                      false
                    )
                    setFieldValue(
                      'sudden_holiday',
                      editSelectedData?.sudden_holiday === true ? 'true' : 'false',
                      false
                    )
                  }

                  if (actionType === 'Add') {
                    setFieldValue(
                      'branchExtendedId',
                      extendedHours
                        ?.filter((items: any) => items.systemName === 'no')
                        .map((item: any) => item.value)
                        .toString(),

                      false
                    )
                  }
                }, [])
                return (
                  <Form>
                    <div className='card-body border-top pt-5'>
                      <div className='row'>
                        <div className='col-md-6 col-xs-12'>
                          <FormSelect
                            labelClassName='col-md-12'
                            containerClassName='col-md-12'
                            placeholder='Please select'
                            label='Category'
                            name='branchCategoryId'
                            onChange={handleChange}
                            errors={errors}
                            touched={touched}
                            options={categoryOptions}
                            values={values}
                            setFieldValue={setFieldValue}
                          />
                        </div>
                        <div className='col-md-6 col-xs-12'>
                          <FormTextBox
                            type='text'
                            labelClassName='col-md-12'
                            containerClassName='col-md-12'
                            placeholder='Enter Branch Code ID'
                            label='Branch Code ID'
                            name='code'
                            onChange={handleChange}
                            errors={errors}
                            touched={touched}
                            required
                          />
                        </div>
                        <>
                          {!isEmpty(values?.branchCategoryId)
                            ? setBranchCategoryValue(values?.branchCategoryId)
                            : ''}
                        </>
                      </div>
                      <div className='row'>
                        <div className='col-md-6 col-xs-12'>
                          <FormTextBox
                            type='text'
                            labelClassName='col-md-12'
                            containerClassName='col-md-12'
                            placeholder={`Branch Title ${hideMultiLanguage ? '' : '(EN)'}`}
                            label={`Branch Title ${hideMultiLanguage ? '' : '(EN)'}`}
                            name='title'
                            onChange={handleChange}
                            errors={errors}
                            touched={touched}
                            required={true}
                          />
                        </div>
                        {hideMultiLanguage ? null : (
                          <div className='col-md-6 col-xs-12'>
                            <FormTextBox
                              type='text'
                              labelClassName='col-md-12'
                              containerClassName='col-md-12'
                              placeholder='Branch Title (NP)'
                              label='Branch Title (NP)'
                              name='title_np'
                              onChange={handleChange}
                              errors={errors}
                              touched={touched}
                            />
                          </div>
                        )}

                        <div className='col-md-6 col-xs-12'>
                          <FormSelect
                            labelClassName='col-md-12'
                            containerClassName='col-md-12'
                            placeholder='Please select province'
                            label='Province'
                            name='provinceId'
                            onChange={handleChange}
                            errors={errors}
                            touched={touched}
                            options={
                              !isEmpty(branchCategoryValue)
                                ? valleyProvinceOptions
                                : provinceOptions
                            }
                            values={values}
                            setFieldValue={setFieldValue}
                          />
                        </div>
                        <>
                          {!isEmpty(values?.provinceId) ? setProvinceValue(values?.provinceId) : ''}
                        </>
                        <div className='col-md-6 col-xs-12'>
                          <FormSelect
                            labelClassName='col-md-12'
                            containerClassName='col-md-12'
                            placeholder='Please select district'
                            label='District'
                            name='districtId'
                            disabled={
                              !isEmpty(editSelectedData) || values?.provinceId ? false : true
                            }
                            onChange={handleChange}
                            errors={errors}
                            touched={touched}
                            options={
                              !isEmpty(branchCategoryValue) && !isEmpty(valleyProvinceOptions)
                                ? valleyDistrictOptions
                                : districtOptions
                            }
                            values={values}
                            setFieldValue={setFieldValue}
                          />
                        </div>

                        <div className='col-md-6 col-xs-12'>
                          <FormTextBox
                            type='text'
                            labelClassName='col-md-12'
                            containerClassName='col-md-12'
                            placeholder='Enter Branch Address'
                            label={`Branch Address ${hideMultiLanguage ? '' : '(EN)'}`}
                            name='address'
                            onChange={handleChange}
                            errors={errors}
                            touched={touched}
                          />
                        </div>
                        {hideMultiLanguage ? null : (
                          <div className='col-md-6 col-xs-12'>
                            <FormTextBox
                              type='text'
                              labelClassName='col-md-12'
                              containerClassName='col-md-12'
                              placeholder='Enter Branch Address (NP)'
                              label='Branch Address (NP)'
                              name='address_np'
                              onChange={handleChange}
                              errors={errors}
                              touched={touched}
                            />
                          </div>
                        )}

                        <MapView
                          latName='latitude'
                          lngName='longitude'
                          location={{
                            lat: values.latitude || defaultLatitude,
                            lng: values.longitude || defaultLongitude,
                          }}
                          setFieldValue={setFieldValue}
                          data-cy='modal-map-view'
                        />

                        <div className='col-md-6 col-xs-12'>
                          <FormTextBox
                            type='text'
                            labelClassName='col-md-12'
                            containerClassName='col-md-12'
                            placeholder='Enter Longitude'
                            label='Longitude'
                            name='longitude'
                            onChange={handleChange}
                            errors={errors}
                            touched={touched}
                          />
                        </div>
                        <div className='col-md-6 col-xs-12'>
                          <FormTextBox
                            type='text'
                            labelClassName='col-md-12'
                            containerClassName='col-md-12'
                            placeholder='Enter Latitude'
                            label='Latitude'
                            name='latitude'
                            onChange={handleChange}
                            errors={errors}
                            touched={touched}
                          />
                        </div>
                        <div className='col-md-6 col-xs-12'>
                          <FormTextBox
                            type='text'
                            labelClassName='col-md-12'
                            containerClassName='col-md-12'
                            placeholder='Enter Google Plus Code'
                            label='Google Plus Code'
                            name='plus_code'
                            onChange={handleChange}
                            errors={errors}
                            touched={touched}
                          />
                        </div>

                        <div className='col-md-6 col-xs-12'>
                          <FormTextBox
                            type='text'
                            labelClassName='col-md-12'
                            containerClassName='col-md-12'
                            placeholder='Enter Telephone'
                            label='Telephone'
                            name='telephone'
                            onChange={handleChange}
                            errors={errors}
                            touched={touched}
                          />
                        </div>
                        {showIframe && (
                          <div className='col-md-6 col-xs-12'>
                            <FormTextBox
                              type='text'
                              labelClassName='col-md-12'
                              containerClassName='col-md-12'
                              placeholder='Enter Iframe'
                              label='Iframe'
                              name='iframe'
                              onChange={handleChange}
                              errors={errors}
                              touched={touched}
                            />
                          </div>
                        )}
                        <div className='col-md-6 col-xs-12'>
                          <FormTextBox
                            type='text'
                            labelClassName='col-md-12'
                            containerClassName='col-md-12'
                            placeholder='Enter Fax Number'
                            label='Fax'
                            name='fax'
                            onChange={handleChange}
                            errors={errors}
                            touched={touched}
                          />
                        </div>
                        <div className='col-md-6 col-xs-12'>
                          <FormTextBox
                            type='text'
                            labelClassName='col-md-12'
                            containerClassName='col-md-12'
                            placeholder='Enter E-mail'
                            label='E-mail'
                            name='email'
                            onChange={handleChange}
                            errors={errors}
                            touched={touched}
                          />
                        </div>
                        {showCrm && (
                          <div className='col-md-6 col-xs-12'>
                            <FormTextBox
                              type='text'
                              labelClassName='col-md-12'
                              containerClassName='col-md-12'
                              placeholder='Enter CRM Code'
                              label='CRM Code'
                              name='crm_code'
                              onChange={handleChange}
                              errors={errors}
                              touched={touched}
                            />
                          </div>
                        )}
                        <div className='col-md-6 col-xs-12'>
                          <FormSelect
                            labelClassName='col-md-12'
                            containerClassName='col-md-12'
                            placeholder='Please select'
                            label='Extended Hours'
                            name='branchExtendedId'
                            onChange={handleChange}
                            errors={errors}
                            touched={touched}
                            options={extendedHours}
                            values={values}
                            setFieldValue={setFieldValue}
                            required={branchExtendedHourRequired ? true : false}
                          />
                        </div>

                        {values?.branchExtendedId === 'bca33c16-f4b3-4bad-8962-086551be8fd2' ? (
                          <>
                            {branchExtendFromDes ? (
                              <>
                                <div className='col-md-6 col-xs-12'>
                                  <FormTinyMce
                                    containerClassName='col-md-12'
                                    label='Branch Description (EN)'
                                    name='description'
                                    initialValue={
                                      !isEmpty(editSelectedData)
                                        ? editSelectedData?.description
                                        : ''
                                    }
                                    handleChange={handleChange}
                                  />
                                </div>
                                <div className='col-md-6 col-xs-12'>
                                  <FormTinyMce
                                    containerClassName='col-md-12'
                                    label='Branch Description (NP)'
                                    name='description_np'
                                    initialValue={
                                      !isEmpty(editSelectedData)
                                        ? editSelectedData?.description_np
                                        : ''
                                    }
                                    handleChange={handleChange}
                                  />
                                </div>
                              </>
                            ) : null}
                            <div className='col-md-3 col-xs-12'>
                              <FormDatepicker
                                labelClassName='col-12'
                                containerClassName='col-12 '
                                dateFormat='hh:mm aa'
                                showTimeSelect={true}
                                showTimeSelectOnly={true}
                                name='openingTime'
                                label='Opening Time'
                                placeholderText='--:-- --'
                                setFieldValue={setFieldValue}
                                value={values.openingTime || false}
                                errors={errors}
                                touched={touched}
                                showIcon={true}
                              />
                            </div>
                            <div className='col-md-3 col-xs-12'>
                              <FormDatepicker
                                labelClassName='col-12'
                                containerClassName='col-12 '
                                dateFormat='hh:mm aa'
                                showTimeSelect={true}
                                showTimeSelectOnly={true}
                                name='closingTime'
                                label='Closing Time'
                                placeholderText='--:-- --'
                                setFieldValue={setFieldValue}
                                value={values.closingTime || false}
                                errors={errors}
                                touched={touched}
                                showIcon={true}
                              />
                            </div>
                          </>
                        ) : null}

                        <div className='col-md-4 col-xs-12'>
                          <label
                            className={`form-label fw-bolder text-dark fs-6 ${
                              branchStatusRequired && 'required'
                            } `}
                          >
                            Status
                          </label>

                          <div className='d-flex ms-5'>
                            {statusOptions?.map((status: {label: string; value: string}) => (
                              <FormRadio
                                containerClassName=''
                                label='Select Status'
                                name='status'
                                type='radio'
                                onChange={handleChange}
                                errors={errors}
                                touched={touched}
                                required={true}
                                checkBoxText={status?.label}
                                value={status?.value}
                              />
                            ))}
                          </div>
                          <div className='fv-plugins-message-container text-danger fw-bolder small text-end mt-1'>
                            <ErrorMessage
                              name='status'
                              component='div'
                              className='field-error-message'
                            />
                          </div>
                        </div>
                        {showCounterHolidayBasedBranch === '1' ? (
                          <main className='row'>
                            {' '}
                            <section className='col-md-6 col-xs-12'>
                              <label
                                className={`form-label fw-bolder text-dark fs-6 ${
                                  branchStatusRequired && 'required'
                                } `}
                              >
                                Evening Counter
                              </label>

                              <div className='d-flex ms-5'>
                                {counterHolidayOptions?.map(
                                  (status: {label: string; value: string}) => (
                                    <FormRadio
                                      containerClassName=''
                                      label='Select Evening Counter'
                                      name='has_evening_counter'
                                      type='radio'
                                      onChange={handleChange}
                                      errors={errors}
                                      touched={touched}
                                      required={true}
                                      checkBoxText={status?.label}
                                      value={status?.value}
                                    />
                                  )
                                )}
                              </div>
                            </section>
                            <section className='col-md-6 col-xs-12'>
                              <label
                                className={`form-label fw-bolder text-dark fs-6 ${
                                  branchStatusRequired && 'required'
                                } `}
                              >
                                Sunday
                              </label>

                              <div className='d-flex ms-5'>
                                {counterHolidayOptions?.map(
                                  (status: {label: string; value: string}) => (
                                    <FormRadio
                                      containerClassName=''
                                      label='Select Sunday'
                                      name='opens_sunday'
                                      type='radio'
                                      onChange={handleChange}
                                      errors={errors}
                                      touched={touched}
                                      required={true}
                                      checkBoxText={status?.label}
                                      value={status?.value}
                                    />
                                  )
                                )}
                              </div>
                            </section>
                            <section className='col-md-6 col-xs-12'>
                              <label
                                className={`form-label fw-bolder text-dark fs-6 ${
                                  branchStatusRequired && 'required'
                                } `}
                              >
                                Public Holiday
                              </label>

                              <div className='d-flex ms-5'>
                                {counterHolidayOptions?.map(
                                  (status: {label: string; value: string}) => (
                                    <FormRadio
                                      containerClassName=''
                                      label='Select Public Holiday'
                                      name='has_public_holiday'
                                      type='radio'
                                      onChange={handleChange}
                                      errors={errors}
                                      touched={touched}
                                      required={true}
                                      checkBoxText={status?.label}
                                      value={status?.value}
                                    />
                                  )
                                )}
                              </div>
                            </section>
                            <section className='col-md-6 col-xs-12'>
                              <label
                                className={`form-label fw-bolder text-dark fs-6 ${
                                  branchStatusRequired && 'required'
                                } `}
                              >
                                Saturday
                              </label>

                              <div className='d-flex ms-5'>
                                {counterHolidayOptions?.map(
                                  (status: {label: string; value: string}) => (
                                    <FormRadio
                                      containerClassName=''
                                      label='Select Saturday'
                                      name='opens_saturday'
                                      type='radio'
                                      onChange={handleChange}
                                      errors={errors}
                                      touched={touched}
                                      required={true}
                                      checkBoxText={status?.label}
                                      value={status?.value}
                                    />
                                  )
                                )}
                              </div>
                            </section>
                            <section className='col-md-6 col-xs-12'>
                              <label
                                className={`form-label fw-bolder text-dark fs-6 ${
                                  branchStatusRequired && 'required'
                                } `}
                              >
                                Sudden Holiday
                              </label>

                              <div className='d-flex ms-5'>
                                {counterHolidayOptions?.map(
                                  (status: {label: string; value: string}) => (
                                    <FormRadio
                                      containerClassName=''
                                      label='Select Sudden Holiday'
                                      name='sudden_holiday'
                                      type='radio'
                                      onChange={handleChange}
                                      errors={errors}
                                      touched={touched}
                                      required={true}
                                      checkBoxText={status?.label}
                                      value={status?.value}
                                    />
                                  )
                                )}
                              </div>
                            </section>{' '}
                          </main>
                        ) : (
                          <section>false</section>
                        )}

                        {branchVisibility && (
                          <div className='col-lg-3'>
                            <label htmlFor=''></label>
                            <FormCheckbox
                              labelClassName='col-md-12'
                              containerClassName='col-md-12 col-lg-12'
                              name='hide_in_website'
                              touched={touched}
                              errors={errors}
                              onChange={handleChange}
                              checkBoxText='Hide in website?'
                              checked={values.hide_in_website}
                            />
                          </div>
                        )}
                        <div className='col-md-3 col-sm-12 col-xs-12'>
                          <label htmlFor=''></label>
                          <div className='row '>
                            {showQOS && (
                              <FormCheckbox
                                labelClassName='col-md-12'
                                containerClassName='col-md-12'
                                name='qos'
                                touched={touched}
                                errors={errors}
                                onChange={handleChange}
                                checkBoxText='Cash Deposit Machine?'
                                checked={values.qos}
                              />
                            )}

                            <FormCheckbox
                              labelClassName='col-md-12'
                              containerClassName='col-md-12'
                              name='upcomingBranchStatus'
                              touched={touched}
                              errors={errors}
                              onChange={handleChange}
                              checkBoxText='Upcoming Branch'
                              checked={values.upcomingBranchStatus}
                            />

                            {showCashCounterStatus && (
                              <FormCheckbox
                                labelClassName='col-md-12'
                                containerClassName='col-md-12'
                                name='cashCounterStatus'
                                touched={touched}
                                errors={errors}
                                onChange={handleChange}
                                checkBoxText='Cash Counter Status'
                                checked={values.cashCounterStatus}
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className='d-flex justify-content-end px-9 '>
                      <button
                        type='submit'
                        disabled={loading}
                        className='btn btn-primary btn-sm ms-3'
                        data-cy='modal-submit'
                      >
                        Save
                      </button>
                      <button
                        type='button'
                        onClick={handleClose}
                        className='btn btn-secondary btn-sm ms-3'
                        data-cy='modal-cancel'
                      >
                        Cancel
                      </button>
                    </div>
                  </Form>
                )
              }}
            </Formik>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  )
}
export default AddBranch
